import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { DossierTerminationReason } from "../../types/Dossier";

type TerminateEmployerDossierPayload = {
  lastDateOfEmployment: string | null;
  targetLastPayrollDate: string | null;
  terminationReason: DossierTerminationReason;
  leavingEmployer: boolean | null;
  driverNotifiedOfTermination: boolean | null;
  noteFromEmployer: string | null;
};

export const terminateEmployerDossier = (
  dossierId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const {
    defaultOnMutateError,
    defaultOnMutateSuccess,
    defaultOnMutateSettled,
  } = useAPQuery();
  const invalidateList = [["employerDossier", dossierId]];

  return useMutation({
    mutationFn: (payload: TerminateEmployerDossierPayload): Promise<string> => {
      return fetchWithAuth<string>("terminateEmployerDossier", dossierId, {
        requestOptions: { method: "post", body: JSON.stringify(payload) },
      });
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
    onSettled: () => defaultOnMutateSettled(invalidateList),
  });
};
